import React, { useEffect, useRef, useState } from 'react'
import styles from '../styles/OptionsModal.module.css'

const OptionsModalOptionDropdown = ({ icon, title, description, items = [] }) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)
  const triggerRef = useRef(null)

  const toggleDropdown = () => {
    setIsOpen(!isOpen)
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        triggerRef.current &&
        !triggerRef.current.contains(event.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen])

  const groupedItems = [items]

  return (
    <div className="mt-3 position-relative">
      <div
        ref={triggerRef}
        className={`${styles.shareOptionsModalOption} d-flex align-items-center justify-content-between p-2 border rounded gap-3 px-3`}
        style={{ height: '100px', cursor: 'pointer' }}
        onClick={toggleDropdown}
      >
        <div className="d-flex align-items-center">
          <img src={icon} alt={title} height="30" width="30" className="me-3" />
          <div className="d-flex flex-column">
            <h6 className="mb-0 fw-bold">{title}</h6>
            <div className="small text-muted">{description}</div>
          </div>
        </div>
        <div className="d-flex justify-content-end">
          <img
            alt="toggle dropdown"
            src="/assets/icons/left.png"
            height={32}
            width={32}
            style={{
              transform: isOpen ? 'rotate(-90deg)' : 'scaleX(-1)',
              transition: 'transform 0.2s ease-in-out'
            }}
          />
        </div>
      </div>

      {isOpen && (
        <div
          ref={dropdownRef}
          className={`position-absolute ${styles.menu} shadow-sm border`}
          style={{
            zIndex: 1050,
            top: 'calc(100% + 4px)'
          }}
        >
          {groupedItems.map((group, groupIndex) => (
            <div key={groupIndex} className={`${styles.contentContainer}`}>
              {group.map((item, itemIndex) => {
                const content = (
                  <>
                    {item.icon && <img src={item.icon} alt="" className={`${styles.img}`} />}
                    <span className={`${styles.contentText}`}>{item.label}</span>
                  </>
                )

                return (
                  <a
                    key={itemIndex}
                    href={item.href}
                    target="_blank"
                    className={`${styles.contentBox} ${item.className || ''}`}
                    onClick={() => setIsOpen(false)}
                    rel="noreferrer"
                  >
                    {content}
                  </a>
                )
              })}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default OptionsModalOptionDropdown
